<template>
    <div class="sell-config">
        <ul class="info-card" v-if="RECVID && APIKEY">  
            <li>                
                <van-row>
                    <van-col span="20"><h3>谷歌秘钥</h3></van-col>
                    <van-col span="4"><van-tag round type="primary" class="testCopy" @click="clipboardText('.testCopy')" :data-clipboard-text="GOOGLE_CODE">复制</van-tag></van-col>
                </van-row>
                <van-row>
                    <van-col span="2">
                        <span class="iconfont icon-a-iconpay_huaban1fuben57" style="font-size:24px; vertical-align: middle; line-height:14px"></span>
                    </van-col>
                    <van-col span="20" style="word-wrap:break-word; line-height:18px">{{GOOGLE_CODE}}</van-col>
                </van-row>
            </li>           
            <li>                
                <h3>验证方式</h3>
                <div class="passtype-radio" @click="changeSellPassType">
                    <p class="item" v-for="(name, index) in passTypes" :key="index" :class="{'checked':index == sellPassType}" :data-index="index" :data-name="name">{{name}}</p>
                </div>
            </li>
        </ul>
        
        <div style="text-align: center; padding: 40px 10px">
            <van-button type="danger" @click="changeGooglePassHandle" block>重新生成谷歌秘钥</van-button>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { Dialog, Toast } from 'vant' 
import Clipboard from 'clipboard'
import { changePassType, changeGooglePass } from '@/api'
import { useStore } from 'vuex'
import { clipboardText } from '@/assets/js/common.js'

export default {
    name: 'SellConfig',
    setup() {
        const state = reactive({
            RECVID: null, 
            APIKEY: null,  
            GOOGLE_CODE: null,          
            passTypes: ['支付密码', '谷歌验证码'],
            sellPassType: 0
        })

        const store = useStore()
        state.sellPassType = state.sellPassTypeOld = store.state.userInfo.SELL_PASSTYPE

        // 切换商户权限验证方式
        const changeSellPassType = e => {
            let tar = e.target
            if (tar.tagName === 'P') {
                let index = tar.getAttribute('data-index') * 1,
                    name = tar.getAttribute('data-name')
                if (state.sellPassType !== index) {
                    Dialog.confirm({
                        title: '切换验证方式',
                        message: `再次进入此页面时将启用 [${name}] 方式验证？`,
                    }).then(() => {
                        changePassType({passtype: index}).then(res => {
                            if (res.code === 200) {
                                Toast.success(res.message)
                                state.sellPassType = index 
                                store.dispatch('getUserInfo', true)                     
                            } else {
                                Toast.fail(res.message)
                            }
                        })
                    })
                }
            }
        }

        // 重新生成谷歌秘钥
        const changeGooglePassHandle = () => {
            Dialog.confirm({
                title: '谷歌秘钥',
                message: '确定重新生成谷歌秘钥？',
            })
            .then(() => {
                changeGooglePass().then(res => {                    
                    if (res.code === 200) {
                         state.GOOGLE_CODE = res.data.GOOGLE_CODE                        
                    } else {
                        Toast.fail(res.message);
                    }
                })
            })
        }

        return {
            ...toRefs(state),
            changeSellPassType,
            changeGooglePassHandle,
            clipboardText
        }
    },
    beforeRouteEnter:function(to, from, next) {
        if (from.name !== 'User') next(from.path)
        const params = to.params || {}
        const { RECVID, APIKEY } = params
        if (RECVID && APIKEY) {
            next()
        } else {
            next(from.path)
        }
	},
    created:function(){
        const { RECVID, APIKEY, GOOGLE_CODE } = this.$route.params
        this.RECVID = RECVID
        this.APIKEY = APIKEY
        this.GOOGLE_CODE = GOOGLE_CODE
	}
}
</script>

<style lang="scss" scoped>
.sell-config {
    padding: h(20) w(10);
    background-color: #eee;
    .info-card {
        background-color: #fff;
        border-radius: 8px;
        padding: 10px 15px;
        li {
            border-bottom: #eee 1px solid;
            padding: 10px 0;
            h3 {
                display: block;
                padding-bottom: 10px;
            }
            .testCopy {
                padding: 0 10px;
            }
            &:last-child{
                border: 0
            }
        }
    }
    .white-list {
        border: #f00 0px solid;
        padding: 20px 0 60px 0;     
        .ip-card {
            padding: 10px 15px;
            border-radius: 10px;
            background-color: #fff;
            margin-bottom: 2px;
            .flex {
                display: flex;
            }
            .ip, .city {
                line-height: 28px;
                flex: 1 1 auto;
                vertical-align: bottom;
            }
            .ip {
                font-size: 22px;
            }
            .city {
                font-size: 14px;
                text-align: right;
                .iconfont {
                    font-size: 30px;
                    vertical-align: bottom;
                }
            }
            .remark {
                color: #999;
                border-top: #eee 1px solid;
                &::before {
                    content: '备注 ';
                    color: #333;
                }
            }
            .btns {
                text-align: right;
                button {
                    margin-left: 20px;
                    padding: 0 20px;
                }
            }
        }
    }
   
    .passtype-radio {
        border: #f00 0px solid;
        .item {
            display: inline-block;
            vertical-align: middle;
            color: #aaa;
            padding: 0 20px 0 10px;
            &::before {
                content: '';
                display: inline-block;
                width: 14px;
                height: 14px;
                border-width: 2px;
                border-style: solid;
                border-color: #ccc;
                border-radius: 50%;
                vertical-align: middle;
                margin-right: 5px;
            }
        }
        .item.checked{
            color: #1989fa;
        }
        .item.checked::before {
            border-width: 7px;
            width: 4px;
            height: 4px;
            border-color: #1989fa;
            color: #1989fa;
        }
    }
    .add-btn {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
    }
       
}
.popup {
    width: 90vw;
    .btns {
        margin: 16px;
        text-align: center;
        button {
            display: inline-block;
            width: 100px;
            margin: 0 20px;
        }
    }
}

</style>
